import LazyLoad from 'react-lazyload';
import * as styles from './styles/styles.module.scss';

export type ActivityRiverItemProps = {
  url: string;
  imgSrc: string;
  title: string;
};

const ActivityRiverItem = ({ url, imgSrc, title = '' }: ActivityRiverItemProps): JSX.Element => {
  return (
    <div className={styles.container} data-testid={title}>
      <a href={url}>
        <LazyLoad>
          <img src={imgSrc} className={styles.image} alt={title} />
        </LazyLoad>
        <div className={styles.title}>{title}</div>
      </a>
    </div>
  );
};

export default ActivityRiverItem;
